/**
 * Analytics consent. Google Analytics sets cookies, so it loads only after the
 * visitor accepts. Strictly necessary cookies (the admin refresh cookie) and
 * cookie-free error monitoring need no consent and are not gated here.
 */
const KEY = 'bs.analytics-consent';

export type Consent = 'accepted' | 'declined' | null;

export function readConsent(): Consent {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'accepted' || v === 'declined' ? v : null;
  } catch {
    return null;
  }
}

export function writeConsent(value: Exclude<Consent, null> | null): void {
  try {
    if (value) localStorage.setItem(KEY, value);
    else localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable: the banner simply shows again next visit */
  }
}

/** True when the build carries a GA id, i.e. there is something to consent to. */
export function analyticsConfigured(): boolean {
  return Boolean(import.meta.env.VITE_GA_MEASUREMENT_ID);
}
